import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { CompanySlice, createCompanySlice } from './company.slice';
import { createFavoritesSlice, FavoritesSlice } from './favorites.slice';
import { createGeneralSlice, GeneralSlice } from './general.slice';
import { createMyCartSlice, MyCartSlice } from './my-cart.slice';
import { createStudioSlice, StudioSlice } from './studio.slice';
import { createUpsellDialogSlice, UpsellDialogSlice } from './upsell-dialog.slice';

type StoreState = MyCartSlice &
  FavoritesSlice &
  GeneralSlice &
  CompanySlice &
  StudioSlice &
  UpsellDialogSlice;

export const useStore = create<StoreState>()(
  persist(
    (...a) => ({
      ...createMyCartSlice(...a),
      ...createFavoritesSlice(...a),
      ...createGeneralSlice(...a),
      ...createCompanySlice(...a),
      ...createStudioSlice(...a),
      ...createUpsellDialogSlice(...a),
      // Add other slices here
    }),
    {
      name: 'app-storage', // Name of the storage
      storage: createJSONStorage(() => localStorage), // Use localStorage
      version: 4,
      migrate: (persistedState, version) => {
        if (!persistedState || typeof persistedState !== 'object') {
          return persistedState as StoreState;
        }

        const state = persistedState as Record<string, unknown>;

        if (version < 4) {
          const oldStudio = state.studio as Record<string, unknown> | undefined;
          state.studio = {
            activeProjectId: oldStudio?.activeProjectId ?? null,
            viewportSize: oldStudio?.viewportSize ?? 'desktop',
          };
        }

        return state as StoreState;
      },
      partialize: state => ({
        myCart: state.myCart,
        favorites: state.favorites,
        general: state.general,
        company: state.company,
        studio: {
          activeProjectId: state.studio.activeProjectId,
          viewportSize: state.studio.viewportSize,
          sidebarOpen: state.studio.sidebarOpen,
        },
      }), // Persist only lightweight UI state for studio — content is loaded from the API
    },
  ),
);
